import FluxStore from "./FluxStore";

import AppConstants from "../constants/AppConstants";

import AppDispatcher from "../dispatcher/AppDispatcher";

import AuthorizeService from "../components/api-authorization/AuthorizeService";

let userProfile = null;

class UserStore extends FluxStore
{
	constructor()
	{
		super();
	}

	areMultipleCurrenciesEnabled()
	{
		return !!this.getUserProfileSetting("multipleCurrenciesEnabled");
	}

	getUserProfile()
	{
		return userProfile;
	}

	getUserProfileSetting(property)
	{
		if (!userProfile)
		{
			return null;
		}
		return userProfile[property];
	}

	async getJwt()
	{
		return await AuthorizeService.getAccessToken();
	}
}

const userStore = new UserStore();

userStore.dispatchToken = AppDispatcher.register((action) => {
	switch (action.actionType) {
		case AppConstants.USERSTORE_RECEIVE_USERPROFILE:
		case AppConstants.USERPROFILE_UPDATE_SUCCESS:
			userProfile = action.userProfile;
			break;

		default:
			return true;
	}

	// If action was responded to, emit change event
	userStore.emitChange();
	return true;
});

export default userStore;



// WEBPACK FOOTER //
// ./Components/stores/UserStore.jsx